export default defineNuxtPlugin(async nuxtApp => {
  const homepagePattern = /^\/[a-z]{2}-[a-z]{2}\/$/
  const isHomepage = homepagePattern.test(nuxtApp._route.path)
  try {
    useScript(
      {
        key: 'ABTastyScript',
        src: 'https://try.abtasty.com/d382a6870f11b809370cc44b5fd6d7f2.js',
        type: 'text/javascript',
        crossorigin: false,
        fetchpriority: 'high',
        defer: false,
      },
      {
        trigger: isHomepage ? 'manual' : 'onNuxtReady',
      }
    )
  } catch (err) {
    console.error('Error loading abTasty script', err)
  }
})
